import * as React from 'react';
import { BodyCell } from '@tableau/widgets-datagrid';
import { databasesWithCrassCellFormatters } from '@tableau/catalog-ui-temp';
import { IColumnFactoryParameters } from '../ListViewGridColumnGenerator';
import * as Layout from '../../../../common/styles/Layout';
import { IconStyle, LabelIconStyle } from '../../../utils/DataCatalogUtils';
import { LabelWrapper } from './Labels';
import { SessionManagementService } from '../../../services/SessionManagementService';

export function DatabaseNameCell(parameters: IColumnFactoryParameters): React.Factory<BodyCell.Props> {
  return React.createFactory(function TableNameCell(props: BodyCell.Props) {
    const nameFactory = databasesWithCrassCellFormatters.name.cellFormatter;
    const typeFactory = databasesWithCrassCellFormatters.typeForCrass.cellFormatter;

    const labels = LabelWrapper(
      {
        catalogEnabled: SessionManagementService.instance.catalogingOnSiteEnabled(),
        content: {
          contentId: props.row.data.graphQLId,
          contentLuid: props.row.data.crassData?.luid,
          contentType: props.row.data.crassData?.type,
          contentName: props.row.data.name,
          subjectArea: props.row.data.crassData?.databaseType,
        },
        includeUpstream: false,
        includeParented: false,
        probablyOrEager: {
          certified: props.row.data.isCertified,
          warning: props.row.data.crassData?.hasActiveDataQualityWarning
            ? { count: 1, value: 'Warning', severe: props.row.data.crassData.hasSevereDataQualityWarning }
            : undefined,
        },
        testId: props.row.data.__typename + '-search-label',
        controls: {
          kind: 'icon',
          siteUrls: parameters.listViewParams.urls,
        },
      },
      parameters.listViewParams.urls,
      props.row.data.crassData?.siteLuid
    );

    // the nameFactory in data-catalog-client-components need to use id with GraphQL id to generate the link.
    // so here we have to assign id ot the GraphQL id.
    props.row.data.id = props.row.data.graphQLId;

    return (
      <div className={Layout.flexH} style={{ width: '100%' }}>
        <div className={IconStyle}>{typeFactory(props)}</div>
        <div className={LabelIconStyle}>{labels}</div>
        <div className={Layout.flexAuto} style={{ overflow: 'hidden' }}>
          {nameFactory(props)}
        </div>
      </div>
    );
  });
}
